import Axios from "axios";
import { Services } from "../Services";

const options = [];
for (let i = 0; i < 50; ++i) {
  options.push({
    value: i + 1,
    label: `Option ${i + 1}`,
  });
}

const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, ms);
  });

export const loadOptions = async (search, prevOptions, { title, page }) => {
  await sleep(1000);

  let filteredOptions = [];
  if (!search) {
    filteredOptions = options;
  } else {
    const searchLower = search.toLowerCase();

    filteredOptions = options.filter(({ label }) =>
      label.toLowerCase().includes(searchLower),
    );
  }

  const hasMore = filteredOptions.length > prevOptions.length + 10;
  const slicedOptions = filteredOptions.slice(
    prevOptions.length,
    prevOptions.length + 10,
  );

  return {
    options: slicedOptions,
    hasMore,
    additional: {
      page: page + 1,
    },
  };
};

export const getFilterData = async (
  search,
  prevOptions,
  { title, page, clients },
) => {
  try {
    if (search && search.length < 4) {
      return {
        options: prevOptions,
        hasMore: true,
        additional: {
          page: page,
          title,
          clients,
        },
      };
    }
    const dicSelect = {
      Pedido: "pedido",
      Proveedor: "proveedor",
      Referencia: "referencia",
      Factura: "factura",
      "Doc. Trans.": "docTrans",
      "País de origen": "paisOrigen",
      DO: "do",
      Aduana: "aduana",
    };
    const url = `${Services.TABLEROS.path}/api/v1/dashboard/getFilters`;
    const auth = localStorage.getItem("token");
    let data = {
      customer: clients,
      search,
      page: page,
      filter: dicSelect[title],
    };
    const response = await Axios.post(url, data, {
      headers: {
        authorization: auth,
      },
    });

    const dataFilters = response?.data?.data;
    const filteredOptions = dataFilters.spGetImportDashboardFilters?.data ?? [];
    const hasMore =
      dataFilters.spGetImportDashboardFilters.totalRecords >
      prevOptions.length + 10;

    const slicedOptions = [...filteredOptions];

    return {
      options: slicedOptions,
      hasMore,
      additional: {
        page: page + 1,
        title,
        clients,
      },
    };
  } catch (error) {
    console.log("🚀 ~  ~ error:", error);
  }
};
